import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgSort({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 17a1 1 0 110 2H3a1 1 0 110-2h6zm6-6a1 1 0 110 2H3a1 1 0 110-2h12zm6-6a1 1 0 110 2H3a1 1 0 010-2h18z"
        fill={color}
      />
    </svg>
  )
}

export default SvgSort
